module.exports = __webpack_public_path__ + "img/129.3.141b623f.png";